import { NavLink, useLocation } from "react-router-dom";
import { Home, FileText, Film, GraduationCap, Sparkles, Settings2 } from "lucide-react";
import { groupFor } from "./SectionTabs";

const NAV = [
    { to: "/", label: "Home", icon: Home, testid: "nav-home", group: null },
    { to: "/videos", label: "Videos", icon: Film, testid: "nav-videos", group: "videos" },
    { to: "/knowledge/documents", label: "Documents", icon: FileText, testid: "nav-documents", group: "documents" },
    { to: "/learning/learners", label: "Learners", icon: GraduationCap, testid: "nav-learners", group: "learners" },
    { to: "/ai/ask", label: "Ask AI", icon: Sparkles, testid: "nav-ask-ai", group: null },
    { to: "/settings", label: "Settings", icon: Settings2, testid: "nav-settings", group: "settings" },
];

function Item({ item }) {
    const { pathname } = useLocation();
    const Icon = item.icon;
    const active = item.group ? groupFor(pathname)?.key === item.group
        : item.to === "/" ? pathname === "/" : pathname.startsWith(item.to);
    return (
        <NavLink
            to={item.to}
            data-testid={item.testid}
            className={`flex items-center gap-3 rounded-md px-3 py-2 text-sm transition-colors ${
                active ? "bg-neutral-100 text-neutral-900 font-medium" : "text-neutral-600 hover:bg-neutral-50 hover:text-neutral-900"
            }`}
        >
            <Icon size={16} strokeWidth={1.75} />
            {item.label}
        </NavLink>
    );
}

export default function Sidebar() {
    return (
        <aside
            data-testid="app-sidebar"
            className="flex h-screen w-64 flex-col border-r border-neutral-200 bg-white"
        >
            <div className="flex h-16 items-center border-b border-neutral-200 px-5">
                <div>
                    <div className="text-sm font-semibold tracking-tight text-neutral-900">
                        ACME-SIPL
                    </div>
                    <div className="mt-0.5 text-[10px] text-neutral-500">
                        Powered by Sanghvi Infotech Pvt Ltd
                    </div>
                </div>
            </div>
            <nav className="flex-1 space-y-1 overflow-y-auto px-3 py-4">
                {NAV.map((it) => <Item key={it.to} item={it} />)}
            </nav>
        </aside>
    );
}
